require('../polyfills/custom_event_polyfill')

const event = new CustomEvent('change');

const mutuallyExclusive = {
    mounted(el, binding, vnode) {
        const checkboxes = el.parentNode.parentNode.parentNode.children

        Array.from(el.parentNode.parentNode.parentNode.children).forEach(function(item) {
            const sibling = item.querySelectorAll('input')[0];
            if (el == sibling) {
                return;
            }
            sibling.addEventListener('change', (evt) => {
                if (sibling.checked) {
                    el.checked = false
                    el.dispatchEvent(event);
                }
                console.log('el.checked: '+el.checked);
            })
        });
    },
    updated(el, binding, vnode) {
        const checkboxes = el.parentNode.parentNode.parentNode.children
        Array.from(el.parentNode.parentNode.parentNode.children).forEach(function(item) {
            const sibling = item.querySelectorAll('input')[0];
            if (el == sibling) {
                return;
            }
            if (el.checked) {
                sibling.checked = false;
                sibling.dispatchEvent(event);
            }
        });
    }
}

export default mutuallyExclusive;